import { render, staticRenderFns } from "./welfareList.vue?vue&type=template&id=33aacca0&scoped=true&"
import script from "./welfareList.vue?vue&type=script&lang=js&"
export * from "./welfareList.vue?vue&type=script&lang=js&"
import style0 from "./welfareList.vue?vue&type=style&index=0&id=33aacca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aacca0",
  null
  
)

export default component.exports